import {
  Box,
  FormControl,
  FormControlProps,
  FormHelperText,
  InputBaseProps,
} from "@mui/material";
import { SxProps } from "@mui/system";
import {
  Controller,
  FieldErrors,
  FieldValues,
  UseControllerProps,
} from "react-hook-form";
import ReactSelect, { createFilter } from "react-select";
import { getError } from "../../../../utils/common";
import styles from "./styles";

type InputProps<T extends FieldValues> = UseControllerProps<T> &
  FormControlProps &
  InputBaseProps & {
    label?: string;
    subLabel?: string;
    errors?: FieldErrors;
    maxLength?: number;
    customStyles?: { [key: string]: SxProps };
    additionalInfo?: string;
    classNamePrefix?: string;
    view?: boolean;
    loading?: boolean;
    placeholder?: string;
    options?: any;
    showSelect?: boolean;
    setValue?: Function;
    onCustomChange?: Function;
    open?: boolean;
  };

const Select = <T extends FieldValues>({
  name,
  control,
  label = "",
  type = "text",
  fullWidth = true,
  errors,
  subLabel = "",
  rules,
  customStyles,
  placeholder,
  classNamePrefix = "",
  maxLength,
  setValue = () => {},
  onCustomChange = () => {},
  inputProps,
  variant = "standard",
  className,
  open = false,
  additionalInfo,
  showSelect = true,
  view = false,
  loading = false,
  options = [],
  ...rest
}: InputProps<T>) => {
  const error = getError(name, errors);

  return (
    <Controller
      render={({ field }) => (
        <FormControl
          sx={{ ...styles.select, ...customStyles?.input } as SxProps}
          fullWidth={fullWidth}
          variant={variant}
          className={className}
        >
          {label && <Box className="select_box_label">{label}</Box>}
          {subLabel && <Box className="select_box_subLabel">{subLabel}</Box>}
          <ReactSelect
            onChange={(e) => {
              field.onChange(e);
              onCustomChange(e);
            }}
            filterOption={createFilter({ matchFrom: "start" })}
            classNamePrefix={classNamePrefix}
            className="select_scroll"
            placeholder={placeholder}
            options={options}
            //[GP]
            // We need to calculate the label dynamically because the entire Option object is stored as a value in the react-hook-forms state.
            // In long term this should be changed to not store labels in the react-hook-forms state.
            getOptionLabel={(option) =>
              options.find((o: any) => o.value === option.value)?.label ??
              option.label
            }
            value={field.value}
          />
          {error && (
            <FormHelperText error>
              {error.message}
            </FormHelperText>
          )}
        </FormControl>
      )}
      name={name}
      control={control}
      rules={rules}
      {...rest}
    />
  );
};
export default Select;
